import React from 'react'
import qs from 'qs'
import { DetailContent } from '../sampleDetail'

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  return <DetailContent
    sampleCode={query.sampleCode}
  />
}
